export class SitContratoEntidade {
	public CD_SITUACAO: number;
	public DS_SITUACAO: string;
	public STATUS: string;
}
